import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function AutocompleteInput({ options, label, onChange, reset = false, defaultValue, disabled = false }) {
  return (
    <Autocomplete
      disabled={disabled}
      defaultValue={defaultValue}
      disableClearable
      key={reset}
      fullWidth
      autoHighlight
      options={options}
      getOptionLabel={(option) => option.label}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'provider'
          }}
        />
      )}
      renderOption={(props, option) => {
        if (!option.label) {
          return null;
        }

        return (
          <li {...props} key={option.label}>
            {option.label}
          </li>
        );
      }}
    />
  );
}

AutocompleteInput.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  reset: PropTypes.bool,
  defaultValue: PropTypes.any
};
